import { createExperimentFormActionMethods } from './Actions';
import { UseCreateExperimentFormArguments, UseCreateExperimentFormReturnType } from './types';

export const useCreateExperimentForm = ({
  shopId,
  dispatch,
  editExperimentFormRoute,
}: UseCreateExperimentFormArguments): UseCreateExperimentFormReturnType => {
  const onCreateDirect = () => {
    if (editExperimentFormRoute) {
      const timestamp = new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
      }).format(new Date());

      dispatch(
        createExperimentFormActionMethods.createExperiment({
          shopId,
          name: `Draft · ${timestamp}`,
          editExperimentFormRoute,
        })
      );
    }
  };

  return {
    onCreateDirect,
  };
};
